import { Photos } from './photos/Photos'
import { Photo } from './photos/photo'
import { Annonces } from './annonces/Annonces'
import { Compte } from './compte/Annonces'
import { UserAnnonces } from './compte/User'

export const AdminPages = {
  Compte,
  Photos,
  Photo,
  Annonces,
  UserAnnonces
}
